<div *ngIf="derivativeCount && derivativePrice$ | async as derivativePrice">
  <div class="d-flex justify-content-between align-items-center udex-px-20 udex-py-32 w-100">
    <udex-link class="navigation__medium--xl" (click)="openDerivativesModal()" design="Emphasized">
      {{ 'configurator.additionalRequiredSolution' | cxTranslate : {count: derivativeCount} }}
    </udex-link>
    <p class="udex-m-0 heading__regular--xxxs">
      {{derivativePrice}}
    </p>
  </div>

  <dcp-additional-required-solutions-modal
    [contractGroup]="providerContract"
    [derivativePrice]="derivativePrice"
    [(isModalOpened)]="isModalOpened"
  ></dcp-additional-required-solutions-modal>
</div>
